export default {
  methods: {
    isOfferTypeCoupon(offerType) {
      return offerType === 'coupon'
    },
    isOfferTypeShow(offerType) {
      return offerType === 'show'
    },
    isOfferTypeUrl(offerType) {
      return offerType === 'url'
    },
    isCouponTypeOnlineOnly(couponType) {
      return couponType === 'online'
    },
    isCouponTypeOnlineStore(couponType) {
      return couponType === 'both'
    },
    isCouponTypeStoreOnly(couponType) {
      return couponType === 'in_store'
    },
    offerTypeName(offerType) {
      switch (offerType) {
        case 'coupon': return 'Coupon Code'
        case 'show': return 'Show and Save'
        case 'url': return 'URL'
        case 'html': return 'HTML'
      }
    },
    couponTypeName(couponType) {
      switch (couponType) {
        case 'online': return 'Online only'
        case 'in_store': return 'In-Store only'
        case 'both': return 'Online and In-Store'
      }
    },
  },
  computed: {
    offerHasVideo() {
      return !!this.offer.videoUrl
    },
    isYoutubeVideo() {
      if (this.offerHasVideo) {
        return this.offer.videoUrl.includes('youtube') || this.offer.videoUrl.includes('youtu.be')
      }
      return false
    },
    videoLink() {
      if (this.offerHasVideo && this.isYoutubeVideo) {
        let videoId = ''
        const url = new URL(this.offer.videoUrl)
        if (url.pathname.includes('watch')) {
          videoId = url.search.replace('?v=', '')
        } else {
          videoId = url.pathname.replace('/', '')
        }
        return `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&autoplay=0`
      }
      if (this.offerHasVideo && !this.isYoutubeVideo) return this.offer.videoUrl
      return ''
    },
  },
}
